import axios from '../../../../api/axios';
import './sectionorgcss.css'
import React, {useState,useEffect} from 'react'
import {EyeFill,PencilFill,Trash3Fill,PersonPlus} from "react-bootstrap-icons"
import { useNavigate,useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import loadingIcon from '../../../../Images/loading.gif'

import { getsession } from '../../../../actions/user.action';
import { getCookie } from '../../../../Utilities/Utils';
import { useAuth } from '../../../../ContextApp/AuthContext';

function Section() {
    let i=0
    const {user}=useAuth();
    const [sections,setSections]=useState([])
    const [curentpage,setCurentpage]=useState(1)
    const [search,setSearch]=useState('')
    const [recordperpage,setRecordperpage]=useState(50)
    let navigate=useNavigate()
    const lastIndex=curentpage * recordperpage
    const firstIndex=lastIndex - recordperpage
    const {id}=useParams()
    const records= search.toLowerCase() === '' ? sections.slice(firstIndex, lastIndex) : sections.filter((section)=>{return search.toLowerCase() === '' ? section : section.nom.toLowerCase().includes(search)}).slice(firstIndex, lastIndex)
    const recordNpage=search.toLowerCase() === '' ? sections : sections.filter((section)=>{ return section.nom.toLowerCase().includes(search)})
    const npage=Math.ceil(recordNpage.length/recordperpage)
    const numbers=[...Array(npage+1).keys()].slice(1)      
   //const recordperpage=2
    const csrf=()=>axios.get('sanctum/csrf-cookie')
    //const numbers=[1,2,3,4,5]
    const [loading,setLoading]=useState(false)
    

    useEffect(
        ()=>{
           // dispatch(getsession(localStorage.getItem('email'),localStorage.getItem("id"),getCookie("gesco_inf")))
            Classes_initialesRequest()
                
        },[])
    const Classes_initialesRequest=async ()=>{
        setLoading(true)
        await axios.get(`/api/sectionorg/${user?.ecole?.id}`).then(
            (res)=>{
                setSections(res.data.items)
                setLoading(false)
                
            }
        ).catch((err)=>{
        
        })
    }
  const Delete=async(section)=>{
    await axios.delete(`api/Sectionorganisee/${section}`).then((res)=>{
        Classes_initialesRequest()
            Swal.fire({
                title:"Réponse du serveur",
                text:res.data.message,
                icon:"success"
            })


    }).catch((err)=>{

    })
  }
    /*const Iteration=()=>{
        return loading ? (
            <div className='w-100 mx-auto'>
                <img src={loadingIcon} alt='loading'/>
            </div>
        ) : (
            
                sections.filter((section)=>{
                    return search.toLowerCase() === '' ? section : section.nom.toLowerCase().includes(search)
                }).map((section,indexV)=>
                {
                  return(
                    <div class="card col-md-4 mx-2 mb-2" >
                    <div class="card-body">
                      <h5 class="card-title">{section.nom}</h5>
                      <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                      {//<a className='btn btn-danger float-end' onClick={()=>navigate(`delete/${section.id}`)}>Delete Section</a>
                      }
                      <a className='btn btn-danger' onClick={()=>AlertNotification(section.id)}>Delete Section</a>
                    </div>
                  </div>
                  )
                    
                }
                )
            
        )
        
            }   */
const Iteration = () => {
    // 1. État de chargement (Loading) élégant
    if (loading) {
        return (
            <div className="col-12 text-center py-5">
                <div className="spinner-border text-primary" role="status" style={{width: '3rem', height: '3rem'}}>
                    <span className="visually-hidden">Chargement...</span>
                </div>
                <p className="mt-3 text-muted fw-light">Chargement des données...</p>
            </div>
        );
    }

    // Filtrage des données
    const filteredSections = sections.filter((section) => {
        return search.toLowerCase() === '' ? section : section.nom.toLowerCase().includes(search);
    });

    // 2. Gestion si aucun résultat n'est trouvé
    if (filteredSections.length === 0) {
        return (
            <div className="col-12 text-center py-5">
                <p className="text-muted italic">Aucune section ne correspond à votre recherche.</p>
            </div>
        );
    }

    // 3. Affichage des cartes
    return filteredSections.map((section, index) => (
        <div className="col-12 col-md-6 col-lg-4 mb-4" key={section.id || index}>
            <div className="card h-100 shadow-sm border-0 hover-shadow transition-all">
                <div className="card-body d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                        <h5 className="card-title fw-bold text-dark mb-0">{section.nom}</h5>
                        <span className="badge bg-soft-primary text-primary">Active</span>
                    </div>
                    
                    <p className="card-text text-muted flex-grow-1">
                        Cette section contient les informations relatives à {section.nom}. 
                        Gérez les élèves et les paramètres spécifiques ici.
                    </p>

                    <div className="mt-3 pt-3 border-top d-flex justify-content-end">
                        <button 
                            className="btn btn-outline-danger btn-sm rounded-pill px-3"
                            onClick={() => AlertNotification(section.id)}
                        >
                            <i className="bi bi-trash me-1"></i> Supprimer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    ));
};
  
            function AlertNotification(idsection){
                Swal.fire({
                    title:'Etes-vous sûr de le supprimer ?',
                    text:'Ce cours sera supprimé',
                    icon:'warning',
                    showDenyButton:true,
                    showCancelButton:true,
                    confirmButtonText:'Confirmer',
                    denyButtonText:'Annuler'
                }).then((resultat)=>{
                    if(resultat.isConfirmed){
                      Delete(idsection)

                            }
                })
            }

    return(
        <>
        <div className="container-fluid py-4">
    {/* En-tête de page stylisée */}
    <div className="card shadow-sm border-0 mb-4 bg-primary text-white">
        <div className="card-body p-4">
            <div className="row align-items-center g-3">
                {/* Titre et Compteur */}
                <div className="col-12 col-md-4 text-center text-md-start">
                    <h3 className="h5 mb-0 fw-bold">
                        Sections <span className="badge bg-white text-primary ms-2">{sections.length}</span>
                    </h3>
                </div>

                {/* Bouton d'action avec effet hover */}
                <div className="col-12 col-md-4 text-center">
                    <button 
                        onClick={() => navigate('insertion')} 
                        className="btn btn-light text-primary fw-semibold shadow-sm w-100 w-md-auto px-4"
                    >
                        <PersonPlus className="me-2" size={20} />
                        Ajouter une section
                    </button>
                </div>

                {/* Barre de recherche moderne */}
                <div className="col-12 col-md-4">
                    <div className="input-group">
                        <span className="input-group-text border-0 bg-white">
                            <i className="bi bi-search text-muted"></i>
                        </span>
                        <input 
                            type="text" 
                            className="form-control border-0 shadow-none" 
                            placeholder="Rechercher une section..." 
                            onChange={(e) => setSearch(e.target.value.toLowerCase())} 
                            value={search} 
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>

    {/* Zone d'affichage des résultats */}
    <div className="row g-4">
        {Iteration()}
    </div>
</div>

        </>
    )

}
export default Section

